import { NextPage, NextPageContext } from 'next'
import * as React from 'react'
import {
  fetchCompanyByMyname,
  getCompanyMemo,
  getCompanyStatus,
  getCompanyContactPerson,
} from '@/lib/api/company'
import {
  ContentfulNpStartupFloatingBanner,
  ContentfulNpStartupSlideArticle,
  ContentfulNpStartupStaticBanner,
} from '../../types'
import {
  CompanyData,
  GetCompanyMemoResult,
  GetCompanyStatusResult,
  GetCompanyContactPersonResult,
  Status,
  CompanyMemo,
  CompanyContactPerson,
} from '../../types/api'
import CompanyPage from '@/components/pages/company/CompanyPage'
import {
  getNpStartupFloatingBanner,
  getNpStartupSlideBannerArticles,
  getNpStartupStaticBanner,
} from '@/lib/api/contentful'
import { getSmartroundUrl } from '@/lib/api/smartround'

type Props = {
  company: Required<CompanyData> | null
  slideBannerArticles: ContentfulNpStartupSlideArticle[] | null
  staticBanners: ContentfulNpStartupStaticBanner[] | null
  floatingBanner: ContentfulNpStartupFloatingBanner[] | null
  smartroundUrl: string | null
  companyMemo: CompanyMemo | null
  companyStatus: Status | null
  companyContactPerson: CompanyContactPerson | null
  reCaptchaEnabled: boolean
}

const CompanyMynamePage: NextPage<Props> = (props) => {
  return <CompanyPage {...props} />
}

CompanyMynamePage.getInitialProps = async (ctx: NextPageContext) => {
  const { myname } = ctx.query
  const company = await fetchCompanyByMyname(ctx, myname as string)

  let slideBannerArticles: ContentfulNpStartupSlideArticle[] | null = null
  let staticBanners: ContentfulNpStartupStaticBanner[] | null = null
  let floatingBanner: ContentfulNpStartupFloatingBanner[] | null = null
  let smartroundUrl: string | null = null
  let companyMemo: GetCompanyMemoResult = { memo: null }
  let companyStatus: GetCompanyStatusResult = { companyStatus: null }
  let companyContactPerson: GetCompanyContactPersonResult = {
    contactPerson: null,
  }

  if (company) {
    ;[slideBannerArticles, staticBanners, floatingBanner, smartroundUrl] =
      await Promise.all([
        getNpStartupSlideBannerArticles(),
        getNpStartupStaticBanner(),
        getNpStartupFloatingBanner(),
        getSmartroundUrl(
          ctx,
          company !== null ? company.corporateNumber : null
        ),
        getCompanyMemo(ctx, company.shortname as string),
        getCompanyStatus(ctx, company.shortname as string),
        getCompanyContactPerson(ctx, company.shortname as string),
      ])
  }

  return {
    company,
    slideBannerArticles,
    staticBanners,
    floatingBanner,
    smartroundUrl,
    companyMemo: companyMemo.memo,
    companyStatus: companyStatus.companyStatus,
    companyContactPerson: companyContactPerson.contactPerson,
    reCaptchaEnabled: false,
  }
}

export default CompanyMynamePage
